import { useState, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import buildUrl from "build-url";

import { filtersToQueryParams, queryToFilters } from "utils/misc";

export default function useFilters(basePath, defaultFilters = {}) {
  const location = useLocation();
  const history = useHistory();
  const [filters, setFilters] = useState(() => ({ ...queryToFilters(location.search, defaultFilters) }));

  useEffect(() => {
    const newFilters = { ...defaultFilters, ...queryToFilters(location.search) };

    setFilters(newFilters);
  }, [location.search, defaultFilters]);

  const handleFilterUpdate = useCallback((newFilters) => {
    // Reset page when changing filters
    if (filters.page && newFilters.page === filters.page) {
      newFilters.page = "0";
    }

    const queryParams = filtersToQueryParams({ ...defaultFilters, ...filters, ...newFilters });
    const newUrl = buildUrl(basePath, { queryParams });
    history.push(newUrl);
  }, [filters, history, basePath, defaultFilters]);

  const clearFilters = useCallback(() => {
    history.push(basePath);
  }, [history, basePath]);

  return {
    filters,
    clearFilters,
    setFilters: handleFilterUpdate,
  };
}
